
const outlets = [
  {
    id: 1,
    slug: "kulche-shulche-citylight",
    name: "Kulche Shulche - City Light",
    address: "L-10, Indraprasth, opp. City Light Shopping Centre, near Ashok Pan House, City Light, Surat",
    phone: "+91 90037 08823",
    email: "kulcheshulche@gmail.com",
    image: "/KS1.png",
    mapLink: "https://maps.app.goo.gl/FnQ5KtdUHwyEvE8C6",
    timings: "6:00 PM - 11:00 PM (Mon), 11:30 AM - 11:00 PM (Tue-Fri), 8:00 AM - 11:00 PM (Sat-Sun)",
    menu: "https://drive.google.com/file/d/1VF_xNQnXz-DnCHvFRF9GgsCeaoozo_Z5/view?usp=sharing",
    swiggyLink: "https://www.swiggy.com/menu/878191?source=sharing",
    zomatoLink: "https://zomato.onelink.me/xqzv/eqz7soz0", 
    gallery: [
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.45.08%E2%80%AFPM.png?updatedAt=1753895849803",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.46.19%E2%80%AFPM.png?updatedAt=1753895854129",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.45.59%E2%80%AFPM.png?updatedAt=1753895853854",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.46.09%E2%80%AFPM.png?updatedAt=1753895850194",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.44.55%E2%80%AFPM.png?updatedAt=1753895849804",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.44.47%E2%80%AFPM.png?updatedAt=1753895849686",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.45.50%E2%80%AFPM.png?updatedAt=1753895849472",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.44.31%E2%80%AFPM.png?updatedAt=1753895845246",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.44.23%E2%80%AFPM.png?updatedAt=1753895845098",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.44.02%E2%80%AFPM.png?updatedAt=1753895845195",
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.57.25%E2%80%AFPM.png?updatedAt=1753896691421", 
      "https://ik.imagekit.io/jo6akqndg/KS1/Screenshot%202025-07-30%20at%2010.58.27%E2%80%AFPM.png?updatedAt=1753896722091"
      // ...
    ],
  },
  {
    id: 2,
    slug: "kulche-shulche-piplod",
    name: "Kulche Shulche - Piplod",
    address: "Bungalow #2, Piplod Main Road, Jalaram Society, Piplod, Surat",
    phone: "+91 90037 08823",
    email: "kulcheshulche@gmail.com",
    image: "/KS2.png",
    mapLink: "https://maps.app.goo.gl/tQ6EXUzxS9uCie5y8",
    timings: "6:00 PM - 11:00 PM (Mon), 11:30 AM - 11:00 PM (All days)",
    menu: "https://drive.google.com/file/d/1VF_xNQnXz-DnCHvFRF9GgsCeaoozo_Z5/view?usp=sharing",
    swiggyLink: "https://www.swiggy.com/city/surat/kulche-shulche-piplod-rest1058695?source=sharing",
    zomatoLink: "https://zomato.onelink.me/xqzv/mbniti37", 
     gallery: [
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.57.42%E2%80%AFPM.png?updatedAt=1753896830180",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.57.55%E2%80%AFPM.png?updatedAt=1753896830118",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.58.01%E2%80%AFPM.png?updatedAt=1753896830307",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.58.08%E2%80%AFPM.png?updatedAt=1753896830388",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.58.17%E2%80%AFPM.png?updatedAt=1753896830473",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2011.00.49%E2%80%AFPM.png?updatedAt=1753896839019",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.59.21%E2%80%AFPM.png?updatedAt=1753896838642",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2011.00.16%E2%80%AFPM.png?updatedAt=1753896838574",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.59.51%E2%80%AFPM.png?updatedAt=1753896838511",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.58.44%E2%80%AFPM.png?updatedAt=1753896834420",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.59.04%E2%80%AFPM.png?updatedAt=1753896834380",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.58.57%E2%80%AFPM.png?updatedAt=1753896834397",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.58.36%E2%80%AFPM.png?updatedAt=1753896834340",
      "https://ik.imagekit.io/jo6akqndg/KS2/Screenshot%202025-07-30%20at%2010.59.58%E2%80%AFPM.png?updatedAt=1753896835123",
    ],
  },
  {
    id: 3,
    slug: "kulche-shulche-pal",
    name: "Kulche Shulche Da Dhaba, Pal",
    address: "Plot D2, Gaurav Path Road, Pal Gam, Surat",
    phone: "+91 90037 08823",
    email: "kulcheshulche@gmail.com",
    image: "/KS3.png",
    mapLink: "https://maps.app.goo.gl/XH6TaigcmDWidrbJ9",
    timings: "2:00 PM - 01:00 AM (All days)",
    menu: "https://drive.google.com/file/d/1VF_xNQnXz-DnCHvFRF9GgsCeaoozo_Z5/view?usp=sharing",
    swiggyLink: "https://www.swiggy.com/city/surat/kulche-shulche-da-dhaba-adajan-rest1207400",
    zomatoLink: "https://www.zomato.com/surat/kulche-shulche-da-dhaba-pal-gam/order", 
     gallery: [],
  },
];

export default outlets;